import { useCallback, useEffect, useState } from 'react';
import { NotificationModelAPI } from '../NotificationModelAPI';
import { NotificationUnreadCountsView } from '../view/NotificationUnreadCountsView';
import { notificationCountsStore } from '../notificationCountsStore';

/**
 * Polls the unread notification counts of the connected back-office user, which feed the header
 * badge, and refreshes at once when something marks notifications as read.
 *
 * @param {boolean} enabled - Whether to enable polling (default: true)
 */
export const useNotificationCounts = (enabled: boolean = true): NotificationUnreadCountsView => {
    const [counts, setCounts] = useState<NotificationUnreadCountsView>(new NotificationUnreadCountsView());

    const fetchCounts = useCallback(async () => {
        try {
            setCounts(await NotificationModelAPI.getUnreadCounts());
        } catch (err) {
            console.error('Error fetching notification counts:', err);
        }
    }, []);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        fetchCounts();
        const interval = setInterval(fetchCounts, 60000);
        // The event carries the fresh counts, so nothing has to be fetched again.
        const unsubscribe = notificationCountsStore.subscribe(setCounts);

        return () => {
            clearInterval(interval);
            unsubscribe();
        };
    }, [enabled, fetchCounts]);

    return counts;
};
